import React from "react";
import cloneDeep from "lodash/cloneDeep";
import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";
import SpaceBetween from "@cloudscape-design/components/space-between";
import FormField from "@cloudscape-design/components/form-field";
import Modal from "@cloudscape-design/components/modal";
/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import {  providerLogStore } from "../stores/providerLog";
import { providerEditModalStore } from "../stores/providerEditModal";
import { providerAddModalStore } from "../stores/providerAddModal";
/* ------- */

class ProvidersLog extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.Interface.loadProviderLog();
	}

	handleKeyPress = (event) => {
		if (event.detail.key === "Enter") {
			this.props.setProviderLog({ ...this.props.providerLog, pagination: { ...this.props.providerLog.pagination, current: 1 } });
			setTimeout(() => {
				this.props.Interface.loadProviderLog();
			}, 0);
		}
	};



	render() {

		return (
			<>
				{this.props.providerLog.loaded && this.props.providerLog.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.providerLog.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.providerLog.error.code} | request timestamp: {this.props.providerLog.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.providerLog.loaded}
					sortingColumn={{ sortingField: this.props.providerLog.sorting.sortingColumn.column }}
					sortingDescending={this.props.providerLog.sorting.isDescending}
					onSortingChange={(sorting) => {
						this.props.setProviderLog({
							...this.props.providerLog,
							sorting: {
								...this.props.providerLog.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? "ASC" : "DESC",
									column: sorting.detail.sortingColumn.sortingField,
								},
								isDescending: sorting.detail.isDescending,
							},
						});
						setTimeout(() => {
							this.props.Interface.loadProviderLog();
						}, 250);
					}}
					columnDefinitions={[
						{
							id: "id",
							header: "ID",
							cell: (item) => item.id,
						},
						{ id: "gameID", header: "gameID",  cell: (item) => item.gameID },
						{ id: "integrator", header: "Integrator",  cell: (item) => item.integrator },
						{ id: "clientID", header: "clientID", cell: (item) => item.clientID },
						{ id: "ClientUserID", header: "ClientUserID",  cell: (item) => item.ClientUserID },
						{ id: "request", header: "Request",  cell: (item) => item.request },
						{ id: "response", header: "Response",  cell: (item) => item.response },
						{ id: "date", header: "Date",  cell: (item) => <>{new Date(item.date).toLocaleDateString() + " " + new Date(item.date).toLocaleTimeString()}</> },
					]}
					items={this.props.providerLog.data}
					filter={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Grid
									gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}
									children={
										<>
											<Input
												disabled={!this.props.providerLog.loaded}
												onKeyDown={this.handleKeyPress}
												disableBrowserAutocorrect={true}
												placeholder="name"
												inputMode="search"
												type="search"
												value={this.props.providerLog.currentSearch}
												onChange={(event) => {
													this.props.setProviderLog({
														...this.props.providerLog,
														currentSearch: event.detail.value,
													});
												}}
											/>
										</>
									}
								/>
							}
						/>
					}
					header={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Header
									children={`Providers log`}
									counter={<>({this.props.providerLog.data.length})</>}
								/>
							}
						/>
					}
					empty="No providers found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const providerLog = useRecoilValue(providerLogStore);
		const setProviderLog = useSetRecoilState(providerLogStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);

		const providerEditModal = useRecoilValue(providerEditModalStore);
		const setProviderEditModal = useSetRecoilState(providerEditModalStore);

		const providerAddModal = useRecoilValue(providerAddModalStore);
		const setProviderAddModal = useSetRecoilState(providerAddModalStore);

		return (
			<Component
				{...props}
				setProviderEditModal={setProviderEditModal}
				providerEditModal={providerEditModal}
				providerLog={providerLog}
				setProviderLog={setProviderLog}
				providerAddModal={providerAddModal}
				setProviderAddModal={setProviderAddModal}
				config={config}
				setConfig={setConfig}
			/>
		);
	};
}

export default withRecoil(ProvidersLog);
